import React, { useEffect, useState } from "react";
import {
  Navbar,
  Nav,
  Button,
  Offcanvas,
  Form,
  Container,
  Spinner,
  Table,
  DropdownButton,
  ButtonGroup,
  NavDropdown,
  Moment,
  Row,
  Col,
} from "react-bootstrap";
import "../style/admin.css";
import { RxHamburgerMenu } from "react-icons/rx";

import axios from "axios";
import { apibasePath } from "../config";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaAngleDown } from "react-icons/fa";

const OrderEntryForm = () => {
  const [logo, setLogo] = useState(null);
  const [brandLogo, setBrandLogo] = useState(null);
  const [name, setName] = useState(" ");
  const [customers, setCustomers] = useState([]);
  const [selectedCustomerCode, setSelectedCustomerCode] = useState([]);
  const [selectedCustomerName, setSelectedCustomerName] = useState([]);
  const [orderNumber, setOrderNumber] = useState("");

  const [show, setShow] = useState(false);
  const [orderDate, setOrderDate] = useState(() => {
    return new Date().toISOString().split("T")[0];
  });

  const [scanData, setScanData] = useState([null]);
  const [inputTags, setInputTags] = useState([""]);
  const [remarks, setRemarks] = useState({});
  const [quantities, setQuantities] = useState({});
  console.log("scanData", scanData.length);
  const Api_url = "https://broker.accountiez.com/client/profiles/company/";

  useEffect(() => {
    const fetchLogo = async () => {
      try {
        const response = await axios.get(Api_url, {
          headers: { "Content-Type": "application/json" },
        });
        setLogo(response.data.logo);
        setName(response.data.name);
      } catch (error) {
        console.error("Error fetching company details:", error);
      }
    };
    fetchLogo();
  }, []);

  const Api = "https://broker.accountiez.com/client/profiles/brand/";

  useEffect(() => {
    const fetchdata = async () => {
      try {
        let response = await axios.get(Api, {
          headers: { "Content-Type": "application/json" },
        });
        console.log("responseeeeeeeeee", response);
        setBrandLogo(response.data.logo);
      } catch (error) {
        console.error(error);
      }
    };

    fetchdata();
  }, []);

  // order entry form

  const allCustomers = async () => {
    try {
      const res = await axios.get(`${apibasePath}/order/all-customers/`, {
        headers: { "Content-Type": "application/json" },
      });
      console.log("API response dd:", res);
      // const customerList = Array.isArray(res.data.data) ? res.data.data : [];
      // console.log(customerList, "customer");

      setCustomers(res.data.customers);
    } catch (error) {
      console.error("Failed to fetch customers", error);
    }
  };

  // latest order
  const customeId = async () => {
    try {
      const resId = await axios.get(`${apibasePath}/order/latest-order/`, {
        headers: { "Content-Type": "application/json" },
      });

      const latest = resId.data.latest_order_number;
      console.log("📦 Latest order number:", latest);

      setOrderNumber(latest + 1); // ✅ Set next order number
    } catch (error) {
      console.error(" Failed to fetch latest order", error);
    }
  };

  // scan Data

  const handleInputChange = (e, index) => {
    const updatedTags = [...inputTags];
    updatedTags[index] = e.target.value;
    setInputTags(updatedTags);
  };

  // set data in localStorage

  const handleKeyPress = async (e, index) => {
    if (e.key === "Enter" && inputTags[index].trim() !== "") {
      const tag = inputTags[index].trim();

      const isDuplicate = scanData.some(
        (item) => item?.item_tag?.toLowerCase() === tag.toLowerCase(),
      );

      if (isDuplicate) {
        toast.error("Item already scanned.", {
          position: "top-right",
        });
        setInputTags((prev) => {
          const updated = [...prev];
          updated[index] = "";
          return updated;
        });
        return;
      }

      try {
        const response = await axios.get(`${apibasePath}/order/stock/${tag}/`, {
          headers: { "Content-Type": "application/json" },
        });

        const data = response?.data?.data;
        console.log("API response data:", data);

        if (data && data.id) {
          //  Check & save ID
          const existingIds = JSON.parse(localStorage.getItem("ids")) || [];
          if (!existingIds.includes(data.id)) {
            const updatedIds = [...existingIds, data.id];
            localStorage.setItem("ids", JSON.stringify(updatedIds));
            console.log(" Stored updated IDs in localStorage:", updatedIds);
          } else {
            console.log(" Duplicate ID not stored:", data.id);
          }

          // Update scan data row
          const newScanData = [...scanData];
          newScanData[index] = data;
          setScanData(newScanData);
          console.log(" Updated scan data:", newScanData);
          //  Add new row if last one
          if (index === scanData.length - 1) {
            setInputTags((prev) => [...prev, ""]);
            setScanData((prev) => [...prev, null]);
          }
        } else {
          console.warn(" Missing ID in data:", data);
        }
      } catch (error) {
        console.error("API error:", error);
        toast.error("Data not found");
      }
    }
  };

  const payload = {
    customer: selectedCustomerName,
    order_date: orderDate,
  };

  // create order number
  const createOrder = async () => {
    console.log("payload", payload);

    try {
      const res = await axios.post(
        `${apibasePath}/order/orders/create/`,
        payload,
        {
          headers: { "Content-Type": "application/json" },
        },
      );

      const orderNumber = res?.data?.order_number;

      if (orderNumber) {
        localStorage.setItem("orderId", orderNumber);

        return true; // Signal success
      } else {
        return false;
      }
      //  customer and date is empty
    } catch (error) {
      console.error(" Failed to create order", error?.response?.data || error);
      return false;
    }
  };

  useEffect(() => {
    const refreshAPIs = async () => {
      try {
        await allCustomers(); // First API
        await customeId(); // Second API (latest order number)
        console.log(" APIs refreshed successfully.");
      } catch (err) {
        console.error(" Error while refreshing APIs:", err);
      }
    };
    refreshAPIs();
  }, []);

  // screen control
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const headerStyle = {
    backgroundColor: "#C5CACF",
    color: "#35646E",
    fontFamily: "Roboto",
  };

  const rowStyle = {
    color: "#35646E",
  };

  // quintity and remarks

  const quintityData = async () => {
    const orderId = localStorage.getItem("orderId");
    const stockIds = JSON.parse(localStorage.getItem("ids")) || [];

    if (!orderId || stockIds.length === 0) {
      return;
    }

    const payloads = {
      order: parseInt(orderId),
      stocks: stockIds,
      remarks: {},
      quantity: {},
    };

    stockIds.forEach((id) => {
      payloads.remarks[id] = remarks?.[id] || "";
      payloads.quantity[id] = parseInt(quantities?.[id]) || 1;
    });

    try {
      const responses = await axios.post(
        `${apibasePath}/order/order-items/create/`,
        payloads,
        {
          headers: { "Content-Type": "application/json" },
        },
      );

      //  Clear local states
      setScanData([
        {
          /* or null if that's your initial */
        },
      ]);
      setInputTags([""]);
      setQuantities({});
      setRemarks({});

      //  Remove stored data
      localStorage.removeItem("ids");
      localStorage.removeItem("orderId");
    } catch (error) {
      if (error.response) {
        console.error(" API Error Response:", error.response);
      } else {
        console.error(" Unknown Error:", error);
      }
    }
  };
  const refreshAPIs = async () => {
    try {
      await allCustomers(); // First API
      await customeId(); // Second API (latest order number)
      console.log("APIs refreshed successfully.");
    } catch (err) {
      console.error(" Error while refreshing APIs:", err);
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    const success = await createOrder(); //  Step 1: Create order

    if (success) {
      await quintityData(); //  Step 2: Submit items (qty, remarks)
      toast.success("order created successfully", {
        position: "top-right",
      });
      //  Step 3: Clear form state
      setSelectedCustomerName("");
      setOrderDate(new Date().toISOString().split("T")[0]);
      setSelectedCustomerCode("");

      //  Step 4: Refresh your APIs only once
      await refreshAPIs();
    }
  };

  // Delete table row

  const handleDeleteRow = (index) => {
    const updatedScanData = [...scanData];
    const updatedInputTags = [...inputTags];
    const removedItem = scanData[index];
    updatedScanData.splice(index, 1);
    updatedInputTags.splice(index, 1);

    // If all rows are removed, keep one empty input row
    if (updatedScanData.length === 0) {
      setScanData([null]);
      setInputTags([""]);
    } else {
      setScanData(updatedScanData);
      setInputTags(updatedInputTags);
    }
    if (removedItem?.id) {
      const existingIds = JSON.parse(localStorage.getItem("ids")) || [];
      const updatedIds = existingIds.filter((id) => id !== removedItem.id);

      if (updatedIds.length === 0) {
        localStorage.removeItem("ids");
      } else {
        localStorage.setItem("ids", JSON.stringify(updatedIds));
      }

      console.log(` Removed ID ${removedItem.id} from localStorage`);
    }
    // ❗ Clear quantity and remarks for this ID
    const updatedQuantities = { ...quantities };
    const updatedRemarks = { ...remarks };
    delete updatedQuantities[removedItem.id];
    delete updatedRemarks[removedItem.id];
    setQuantities(updatedQuantities);
    setRemarks(updatedRemarks);

    // clear selected customer
    setSelectedCustomerName("");
    setSelectedCustomerCode("");
    setOrderDate(new Date().toISOString().split("T")[0]);
  };

  useEffect(() => {
    const ids = JSON.parse(localStorage.getItem("ids")) || [];
    if (ids.length === 0) {
      localStorage.removeItem("ids");
    }
  }, []);


  return (
    <>
      {/* <div className="container-fluid" style={{width:"100%",height:"100%" }}> */}
      {/* Top Navbar */}
      {/* <Navbar bg="light" variant="dark" expand="lg" className="px-3 fixed-top">
        <Container fluid>
          <Navbar.Brand className="ms-2">
            <div className="logo-container">
              {logo && <img src={logo} alt="Company Logo" />}
            </div>
          </Navbar.Brand>
          <Navbar.Brand
            style={{
              color: "#23395B",
              fontFamily: "Roboto",
              fontWeight: "600",
              marginRight: "auto",
              fontSize: "17px",
            }}
          >
            {name}
          </Navbar.Brand>

          <Navbar.Brand
            style={{
              color: "#23395B",
              fontFamily: "Roboto",
              fontWeight: "600",
              marginRight: "auto",
              fontSize: "25px",
            }}
          >
            {" "}
            ORDER ENTRY FORM
          </Navbar.Brand>
          <Button
            variant="outline-light"
            className="d-lg-none"
            onClick={handleShow}
          >
            <RxHamburgerMenu
              style={{
                width: "30px",
                height: "30px",
                cursor: "pointer",
                color: "#000",
              }}
            />
          </Button>
        </Container>
      </Navbar> */}



      {/* Main Content */}

      <main className="content">
        {/* Page Data */}
        <div className="header-section">
          <Row
            className="align-items-end justify-content-between gap-4 w-100 "
            // style={{ display: "flex" }}
          >
            <Col   className="" >
              <Form.Group as={Row} controlId="orderNo">
                <Form.Label
                  column
                  sm="3"
                  style={{
                    color: "#226963",
                    fontFamily: "Roboto",
                    fontWeight: "600",
                    width: "145px",
                    fontSize: "20px",
                  }}
                >
                  Order No : {orderNumber}
                </Form.Label>
              </Form.Group>

              <Form.Group as={Row} controlId="orderDate">
                <Form.Label
                  column
                  sm="3"
                  style={{
                    color: "#226963",
                    fontFamily: "Roboto",
                    fontWeight: "600",
                    width: "138px",
                    fontSize: "20px",
                  }}
                >
                  Order Date :
                </Form.Label>
                <Col sm="5">
                  <input
                    type="date"
                    value={orderDate}
                    onChange={(e) => setOrderDate(e.target.value)}
                    style={{
                      borderColor: "#226963",
                      borderRadius: "5px",
                      marginTop: "10px",
                      maxWidth:'250px'
                    }}
                  />
                </Col>
              </Form.Group>
            </Col>
            <Col    className="mt-2 mt-md-0 ">
              {/* customer dropdown */}
              <Form.Group className="d-flex flex-column align-items-end justify-content-end" >
                <div className="position-relative " style={{width:'max-content'}} >
                  <FaAngleDown className="position-absolute   text-white fs-4   " style={{ right: '10px',top:'13px' }} />

                  <Form.Select
                    className="text-white"
                    value={selectedCustomerName}
                    onChange={(e) => {
                      const selectedId = e.target.value;

                      // Find the full customer object
                      const selectedCustomer = customers.find(
                        (cust) => String(cust.id) === String(selectedId),
                      );

                      // Set both name and code
                      setSelectedCustomerName(selectedCustomer?.id || "");
                      setSelectedCustomerCode(
                        selectedCustomer?.customer_code || "---",
                      );
                    }}
                    style={{
                      backgroundColor: "#226963",
                      fontFamily: "Roboto",
                      fontWeight: "600",
                      marginRight: "auto",
                      fontSize: "20px",
                      color: "white",
                      width: "450px",
                      appearance: 'none'

                    }}
                  >

                    <option value="">Select Customer Name</option>
                    {Array.isArray(customers) &&
                      customers.map((customer) => (
                        <option key={customer.customer_code} value={customer.id}>
                          {customer.customer_name}
                        </option>
                      ))}
                  </Form.Select>

                </div>
                <div className="" style={{ display: "flex", gap: "11%", justifyContent:'end' }}>
                  <div>
                    <Col
                      className="p-3"
                      style={{
                        color: "#226963",
                        fontFamily: "Roboto",
                        fontWeight: "600",
                        fontSize: "20px",
                        width: "250px",
                      }}
                    >
                      <strong>Customer code :</strong> {selectedCustomerCode}
                    </Col>
                  </div>
                  <div className="mt-3">
                    <Col>
                      <Button
                        onClick={handleSubmit}
                        disabled={
                          !selectedCustomerName || scanData.length === 1
                        }
                        style={{
                          backgroundColor: "#226963",
                        }}
                      >
                        Submit
                      </Button>

                      <ToastContainer />
                    </Col>
                  </div>
                </div>
              </Form.Group>
            </Col>
          </Row>
        </div>
        <Table className="table mt-3" responsive striped bordered hover>
          <thead>
            <tr style={{ color: "#35646E", borderBottom: "1px solid black" }}>
              {[
                "S.No",
                "Scan Data",
                "Item Code",
                "Tag No",
                "Order Qty",
                "Comments",
                "Gr Wt",
                "Tr Wt",
                "Net Wt",
                "Actions",
              ].map((header, idx) => (
                <th
                  key={idx}
                  style={{
                    backgroundColor: "#C5CACF",
                    color: "#35646E",
                    fontFamily: "Roboto",
                  }}
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {scanData.map((item, index) => (
              <tr key={index} style={rowStyle}>
                <td style={headerStyle}>{index + 1}</td>
                <td style={headerStyle}>
                  <input
                    type="text"
                    value={inputTags[index] || ""}
                    onChange={(e) => handleInputChange(e, index)}
                    onKeyDown={(e) => handleKeyPress(e, index)}
                    required
                  />
                </td>

                <td style={headerStyle}>{item?.item_code || "N/A"}</td>
                <td style={headerStyle}>{item?.tag || "N/A"}</td>
                <td style={headerStyle}>
                  <input
                    type="number"
                    value={
                      item?.id
                        ? quantities[item.id] !== undefined
                          ? quantities[item.id]
                          : 1
                        : ""
                    }
                    placeholder="1"
                    onChange={(e) =>
                      item?.id &&
                      setQuantities((prev) => ({
                        ...prev,
                        [item.id]:
                          e.target.value === ""
                            ? ""
                            : parseInt(e.target.value, 10),
                      }))
                    }
                  />
                </td>
                <td style={headerStyle}>
                  <input
                    type="text"
                    value={item?.id ? (remarks[item.id] ?? "") : ""}
                    onChange={(e) =>
                      item?.id &&
                      setRemarks((prev) => ({
                        ...prev,
                        [item.id]: e.target.value,
                      }))
                    }
                  />
                </td>
                <td style={headerStyle}>{item?.gross_weight || "N/A"}</td>
                <td style={headerStyle}>
                  {" "}
                  {item?.stone_weight != null
                    ? item.stone_weight.toFixed(2)
                    : "N/A"}
                </td>
                <td style={headerStyle}>{item?.net_weight || "N/A"}</td>
                <td style={headerStyle}>
                  <button
                    onClick={() => handleDeleteRow(index)}
                    disabled={
                      !inputTags[index] || inputTags[index].trim() === ""
                    }
                    style={{
                      backgroundColor: "#226963",
                      color: "white",
                      opacity:
                        !inputTags[index] || inputTags[index].trim() === ""
                          ? 0.5
                          : 1,
                      cursor:
                        !inputTags[index] || inputTags[index].trim() === ""
                          ? "not-allowed"
                          : "pointer",
                    }}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>


      </main>
    </>
  );
};

export default OrderEntryForm;
